import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=e9980704&scoped=true&lang=pug&"
import script from "./AcceptInvite.vue?vue&type=script&lang=js&"
export * from "./AcceptInvite.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInvite.vue?vue&type=style&index=0&id=e9980704&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9980704",
  null
  
)

export default component.exports